import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import HomeService from "../../../Services/HomeService";
import toast from "react-hot-toast";
import HttpClientXml from "../../../utils/HttpClientXml";
import noimage from "../../../Images/noImage.jpg"
import moment from "moment";

const DeletedWorksheetTable = forwardRef((props, ref) => {
   // const WorksheetTable = ({ tableData, pcity, ptype, reload, cityName, propertyTypeName }) => {

   const [preId, setPreId] = useState("")
   const [newDisplayOrderNumber, setNewDisplayOrderNumber] = useState(1)

   const [localities, setLocalities] = useState([]);
   // Fetch localities
   const fetchLocalities = async (cityId) => {
      try {
         const res = await HomeService.getLocalities();
         console.log("HYT71", res);

         if (res?.data) {
            setLocalities(res.data.filter((item) => item?.city?._id === cityId));
         }
      } catch (error) {
         console.error("Error fetching localities:", error);
      }
   }

   const [data, setData] = useState(props.tableData)
   console.log("UYY27", data);

   const initialData = {
      // _id: Date.now(),
      action: 'insert',
      remarks: '',
      status: '0',
      // cityName: 'Gurgaon',
      city: props.pcity,
      // propertyType: 'Builder Floor Sale',
      propertyType: props.ptype,
      locality: localities[0]?._id || '',
      address: '',
      // $: '',
      area: '',
      floor: '',
      bhk: '',
      ownerName: '',
      phoneNo: '',
      // extra: '',
      price: '',
      order: 0,
      newEntry: ""
   }

   // const _handleInsert = (id) => {
   //    setData([...data], data.find(item => item._id === id).insertRow.push(initialData))
   // }

   const handleInsertRow = (targetId, targetDisplayOrder) => {
      if (preId) {
         // return
      } else {
         setPreId(targetId)
         setNewDisplayOrderNumber(targetDisplayOrder)
      }
      const index = data.findIndex(record => record._id === targetId)
      let updatedRecords = [...data];
      if (index !== -1) {
         if (index !== -1) {
            updatedRecords.splice(index + 1, 0, initialData);
         }
         console.log("OOI34", updatedRecords);

         setData(updatedRecords)
      }
   }

   const handleCancelRow = (index) => {
      setPreId(null)
      setNewDisplayOrderNumber(0)
      let updatedRecords = [...data];
      updatedRecords.splice(index, 1);
      setData(updatedRecords)
   }

   const handleDeleteData = async (id) => {
      setPreId(null)
      // setNewDisplayOrderNumber(0)
      try {
         const res = await HomeService.deleteWorksheetProperty(id);
         if (res?.success) {
            toast.success("Row removed successfully!");
         } else {
            toast.error(res?.error)
         }
      } catch (error) {
         toast.error("Failed to remove property.");
         console.error("Error removing property:", error);
      }

      props.reload()
   }

   useImperativeHandle(ref, () => ({
      handleInsertFirst: () => {
         // alert(48)
         const index = -1
         let updatedRecords = [...data]
         updatedRecords.splice(index + 1, 0, initialData);
         setData(updatedRecords)
      },
      handleDeleteAllNewEntry: async (queryText, city, propertyType) => {
         // alert(48)

         const queryData = {
            newEntry: queryText,
            city: city,
            propertyType: propertyType,
         }
         // console.log("YYTR119",queryData);
         // return
         try {
            const res = await HomeService.deleteBulkProperties(queryData);
            if (res?.success) {
               toast.success("Row(s) removed successfully!");
            } else {
               toast.error(res?.message)
            }
         } catch (error) {
            toast.error("Failed to remove property.");
            console.error("Error removing property:", error);
         }

         console.log("SER127", queryData);
         props.reload()
      },
      saveAll: async () => {

         const updatedData = data
            .map((property, index) => {
               const { action, ...rest } = property;
               return { ...rest, order: index + 1 }; // Add order field
            });

         const transformedData = updatedData.map((property) => ({
            // _id: property._id,
            order: property?.order,
            date: moment(property?.date).format("YYYY-MM-DD"),
            newEntry: property?.newEntry,
            propertyFor: property?.propertyFor,
            address: property?.address,
            area: property?.area,
            bhk: property?.bhk,
            floor: property?.floor,
            ownerName: property?.ownerName,
            price: property?.price,
            phoneNo: property?.phoneNo,
            images: property?.images,
            status: property?.status ? true : false,
            remarks: property?.remarks,
            age: property?.age,
            aptName: property?.aptName,
            //createdOn: property?.createdOn,
            propertyType: property?.propertytype?._id || property?.propertyType || props.ptype,
            city: property?.city?._id || property?.city || props.pcity,
            locality: property?.locality?._id || property?.locality,
            facing: property?.facing?._id || property?.facing,
            surveyorId: property?.surveyor?._id || property?.surveyorId,
            telecallerId: property?.telecaller?._id || property?.telecallerId,
         }));

         const bulkData = { properties: transformedData }
         console.log("YTR285", updatedData, bulkData);
         // return
         try {
            const res = await HomeService.addBulkProperties(bulkData);
            if (res?.status) {
               toast.success("Property added successfully!");
            } else {
               toast.error("No Properties found!")
            }
         } catch (error) {
            toast.error("Failed to add property.");
            console.error("Error adding property:", error);
         }
      }


   }));

   useEffect(() => {
      fetchLocalities(props.pcity)
      fetchFacings()
      fetchAllStaff()
   }, [props.pcity])




   const handleInsertData = async (index) => {
      setPreId(null)
      // setNewDisplayOrderNumber(0)
      const { _id, action, extra, ...modifiedObject } = data[index];
      console.log("INS90", { ...modifiedObject, order: newDisplayOrderNumber + 1 }, preId, newDisplayOrderNumber);

      const formData = { ...modifiedObject, order: newDisplayOrderNumber + 1 }
      try {
         const res = await HomeService.addPropertyWorksheetRow(formData);
         if (res?.success) {
            toast.success("Row inserted successfully!");
         } else {
            toast.error(res?.error)
         }
      } catch (error) {
         toast.error("Failed to add property.");
         console.error("Error adding property:", error);
      }

      props.reload()
   }

   useEffect(() => {
      setData(props.tableData)
   }, [props.tableData])

   const handleChange = (i, e) => {
      let newFormValues = [...data];
      newFormValues[i][e.target.name] = e.target.value;
      setData(newFormValues);
   };


   // Fetch Facings
   const [facings, setFacings] = useState([]);
   const fetchFacings = async () => {
      try {
         const res = await HomeService.getFacings();
         if (res?.data) {
            setFacings(res.data);
         }
      } catch (error) {
         console.error("Error fetching facings:", error);
      }
   }

   // Fetch Staffs
   const [salesStaff, setSalesStaff] = useState([])
   const [surveyStaff, setSurveyStaff] = useState([])
   const [telecallingStaff, setTelecallingStaff] = useState([])
   const [dataentryStaff, setDataentryStaff] = useState([])

   const fetchAllStaff = async () => {
      try {
         const res = await HomeService.getStaffs();
         console.log("JYT47", res?.data);

         if (res?.data) {
            setSalesStaff(res?.data.filter((item) => item.role === "sales" && item?.city._id === props.pcity))
            setTelecallingStaff(res?.data.filter((item) => item.role === "telecalling" && item?.city._id === props.pcity))
            setSurveyStaff(res?.data.filter((item) => item.role === "survey" && item?.city._id === props.pcity))
            setDataentryStaff(res?.data.filter((item) => item.role === "data entry" && item?.city._id === props.pcity))
         }
      } catch (error) {
         console.error("Error fetching staffs:", error);
      }
   }

   const handleImageUpload = async (i, e) => {
      e.preventDefault()
      console.log("RRE214", i, e);

      const files = Array.from(e?.target?.files || []);
      const uploadedImages = [];

      for (let j = 0; j < files.length; j++) {
         const formData = new FormData();
         formData.append("image", files[j]);

         try {
            const res = await HttpClientXml.fileUplode(
               "image-upload",
               "POST",
               formData
            );
            if (res?.image) {
               uploadedImages.push(res.image);
            }
         } catch (error) {
            toast.error("Failed to upload image: " + files[j].name);
            console.error("Error uploading image:", error);
         }
      }

      let newFormValues = [...data];
      const existingImages = newFormValues[i][e?.target?.name] || [];
      newFormValues[i][e?.target?.name] = [...existingImages, ...uploadedImages];
      setData(newFormValues);

      toast.success("Images uploaded successfully!");
   };

   console.log("VFR92", preId);

   const _saveAll = async () => {

      const updatedData = data
         .map((property, index) => {
            // Remove "action" field by destructuring the object
            const { action, ...rest } = property;
            return { ...rest, order: index + 1 }; // Add order field
         });

      const transformedData = updatedData.map((property) => ({
         // _id: property._id,
         order: property?.order,
         date: moment(property?.date).format("YYYY-MM-DD"),
         newEntry: property?.newEntry,
         propertyFor: property?.propertyFor,
         address: property?.address,
         area: property?.area,
         bhk: property?.bhk,
         floor: property?.floor,
         ownerName: property?.ownerName,
         price: property?.price,
         phoneNo: property?.phoneNo,
         images: property?.images,
         status: property?.status ? true : false,
         remarks: property?.remarks,
         age: property?.age,
         aptName: property?.aptName,
         //createdOn: property?.createdOn,
         propertyType: property?.propertytype?._id || property?.propertyType || props.ptype,
         city: property?.city?._id || property?.city || props.pcity,
         locality: property?.locality?._id || property?.locality,
         facing: property?.facing?._id || property?.facing,
         surveyorId: property?.surveyor?._id || property?.surveyorId,
         telecallerId: property?.telecaller?._id || property?.telecallerId,
      }));

      const bulkData = { properties: transformedData }
      console.log("YTR285", updatedData, bulkData);
      // return
      try {
         const res = await HomeService.addBulkProperties(bulkData);
         if (res?.status) {
            toast.success("Property added successfully!");
         } else {
            toast.error("No Properties found!")
         }
      } catch (error) {
         toast.error("Failed to add property.");
         console.error("Error adding property:", error);
      }
   }

   return (
      <>
         <div className="bottom-btn-container">
            <table className="worksheet_table_wrapper">
               <thead>
                  <tr>
                     {/* <th className="work_head1">Action</th> */}
                     <th className="work_head1">Date</th>
                     <th className="work_head1">Telecaller</th>
                     <th className="work_head1">Surveyor</th>
                     <th className="work_head1">Photo</th>
                     <th className="work_head2">Feedback</th>
                     <th className="work_head2">Available For</th>
                     <th className="work_head3">Status</th>
                     <th className="work_head4">City</th>
                     <th className="work_head5">Property Type</th>
                     <th className="work_head6">Locality</th>
                     <th className="work_head6">Apartment</th>
                     <th className="work_head7">Address</th>
                     <th className="work_head7">Age</th>
                     <th className="work_head7">Facing</th>
                     <th className="work_head8">New($)</th>
                     <th className="work_head9">Area</th>
                     <th className="work_head10">Floors</th>
                     <th className="work_head11">BHK</th>
                     <th className="work_head12">Owner</th>
                     <th className="work_head13">Contact</th>
                     <th className="work_head14" >Extra</th>
                     <th className="work_head15">Pricing</th>
                  </tr>
               </thead>

               <tbody>
                  {data.length > 0 ? data.map((e, i) => (
                     <>
                        <tr key={i} className={e.action ? "newRow" : ""}>
                           {/* {e.action ? <td>
                              <div className="work_action">
                                 <button style={{
                                    padding: '5px 10px',
                                    border: 'none',
                                    background: '#85da4f',
                                    color: '#fff',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    fontWeight: '600'
                                 }}
                                    onClick={(() => handleInsertData(i))}
                                 >Insert</button>
                                 <button onClick={(() => handleCancelRow(i))} className="work_action_delete_btn"><i class="fa-solid fa-xmark"></i></button>
                              </div>
                           </td> : <td>
                              <div className="work_action">
                                 <button onClick={(() => handleInsertRow(e._id, e?.order || 0))} className="work_action_edit_btn"><i class="fa-solid fa-plus"></i></button>
                                 <button onClick={(() => handleDeleteData(e._id))} className="work_action_delete_btn"><i class="fa-solid fa-trash"></i></button>
                              </div>
                           </td>} */}
                           <td>
                              <input
                                 type="date"
                                 name="date"
                                 value={e?.date && new Date(e?.date).toISOString().split("T")[0]}
                                 onChange={(e) => handleChange(i, e)}
                              />
                           </td>
                           <td>
                              <select
                              className="none-select"
                                 name="telecallerId"
                                 value={e.telecallerId || e?.telecaller?._id}
                                 onChange={(e) => handleChange(i, e)}
                                 disabled
                              >
                                 <option value="">N/A</option>
                                 {telecallingStaff.map((item, key) => (
                                    <option key={key} value={item._id}>
                                       {`${item?.name} (${item?.designation?.name})`}
                                    </option>
                                 ))}
                              </select>
                           </td>
                           <td>
                              <select
                              className="none-select"
                                 name="surveyorId"
                                 value={e.surveyorId || e?.surveyor?._id}
                                 onChange={(e) => handleChange(i, e)}
                                 disabled
                              >
                                 <option value="">N/A</option>
                                 {surveyStaff.map((item, key) => (
                                    <option key={key} value={item._id}>
                                       {`${item?.name} (${item?.designation?.name})`}
                                    </option>
                                 ))}
                              </select>
                           </td>
                           <td style={{ display: "block", padding: "10px 0" }}>
                              <img src={e?.images[0] || noimage} style={{ width: "100%" }} alt="..." />
                              {/* <input
                                 type="file"
                                 name="images"
                                 onChange={(e) => handleImageUpload(i, e)}
                                 accept="image/*"
                              /> */}
                           </td>
                           <td>
                              <input
                                 name="remarks"
                                 value={e?.remarks || ""}
                                 onChange={(e) => handleChange(i, e)}
                              />
                           </td>
                           <td>
                              <select
                              className="none-select"
                                 name="propertyFor"
                                 value={e.propertyFor}
                                 onChange={(e) => handleChange(i, e)}
                                 disabled
                              >
                                 <option value="">N/A</option>
                                 <option value="sales">Sales</option>
                                 <option value="rent">Rent</option>
                              </select>
                           </td>
                           {e.status && <td>
                              <select
                              className="none-select"
                                 name="status"
                                 value={e.status}
                                 onChange={(e) => handleChange(i, e)}
                              >
                                 <option value={false}>{0}</option>
                                 <option value={true}>{1}</option>
                              </select>
                           </td>}
                           <td>{props.cityName(e?.city?._id || props.pcity)}</td>
                           <td>{props.propertyTypeName(e?.propertytype?._id || props.ptype)}</td>
                           <td>
                              <select
                              className="none-select"
                                 name="locality"
                                 value={e.locality?._id}
                                 onChange={(e) => handleChange(i, e)}
                                 disabled
                              >
                                 <option value="">N/A</option>
                                 {localities.map((item, key) => (
                                    <option key={key} value={item._id}>
                                       {item.name}
                                    </option>
                                 ))}
                              </select>
                           </td>
                           <td>
                              <input
                                 name="aptName"
                                 value={e?.aptName || ""}
                                 onChange={(e) => handleChange(i, e)}
                              />
                           </td>
                           <td>
                              <input
                                 name="address"
                                 value={e?.address || ""}
                                 onChange={(e) => handleChange(i, e)}
                              />
                           </td>
                           <td>
                              <input
                                 name="age"
                                 value={e?.age || ""}
                                 onChange={(e) => handleChange(i, e)}
                              />
                           </td>
                           <td>
                              <select
                                 className="none-select"
                                 name="facing"
                                 value={e.facing?._id}
                                 onChange={(e) => handleChange(i, e)}
                                 disabled
                              >
                                 <option value="">N/A</option>
                                 {facings.map((item, key) => (
                                    <option key={key} value={item._id}>
                                       {item.facing}
                                    </option>
                                 ))}
                              </select>
                           </td>
                           <td>
                              <input
                                 name="newEntry"
                                 value={e?.newEntry || ""}
                                 onChange={(e) => handleChange(i, e)}
                              />
                           </td>
                           <td>
                              <input
                                 name="area"
                                 value={e?.area || ""}
                                 onChange={(e) => handleChange(i, e)}
                              />
                           </td>
                           <td>
                              <input
                                 name="floor"
                                 value={e?.floor || ""}
                                 onChange={(e) => handleChange(i, e)}
                              />
                           </td>
                           <td>
                              <input
                                 name="bhk"
                                 value={e?.bhk}
                                 onChange={(e) => handleChange(i, e)}
                              />
                           </td>
                           <td>
                              <input
                                 name="ownerName"
                                 value={e?.ownerName || ""}
                                 onChange={(e) => handleChange(i, e)}
                              />
                           </td>
                           <td>
                              <input
                                 name="phoneNo"
                                 value={e?.phoneNo || ""}
                                 onChange={(e) => handleChange(i, e)}
                              />
                           </td>
                           <td>
                              <input
                                 name="extra"
                                 // placeholder={e?.order}
                                 value={e?.extra || ""}
                                 onChange={(e) => handleChange(i, e)}
                              />
                           </td>
                           <td>
                              <input
                                 name="price"
                                 value={e?.price || ""}
                                 onChange={(e) => handleChange(i, e)}
                              />
                           </td>
                        </tr>
                        {/* {e.insertRow?.map((item, index) => (
                        <tr>
                           <td>{item.feedback}</td>
                           {item.status && <td>
                              <select>
                                 <option value={item.status}>{item.status}</option>
                              </select>
                           </td>}
                           <td>
                              {item?.city}
                           </td>
                           <td>
                              {item.propertyType}
                           </td>
                           {item?.locality && <td>
                              <select>
                                 <option value={item?.locality}>{item?.locality}</option>
                              </select>
                           </td>}
                           <td>
                              <input defaultValue={item.address}></input>
                           </td>
                           <td>
                              <input defaultValue={item.dollar}></input>
                           </td>
                           <td>
                              <input defaultValue={item.area}></input>
                           </td>
                           <td>
                              <input defaultValue={item.floors}></input>
                           </td>
                           <td>
                              <input defaultValue={item.bhk}></input>
                           </td>
                           <td>
                              <input defaultValue={item.owner}></input>
                           </td>
                           <td>
                              <input defaultValue={item.contact}></input>
                           </td>
                           <td>
                              <input defaultValue={item.extra}></input>
                           </td>
                           <td>
                              <input defaultValue={item.pricing}></input>
                           </td>

                        </tr>
                     ))} */}
                     </>
                  )) : <><tr><td colSpan={23} style={{ textAlign: "center", fontWeight: "normal", color: "#ff0000" }}>
                     {props.pcity && props.ptype ? props.loading ? "Loading data..." : "No records found!" : "Choose City and Property Type"}
                  </td></tr></>}

               </tbody>
            </table>
            {/* <button className="bottom-btn" onClick={saveAll} >Save</button> */}
         </div>
      </>
   )
})

export default DeletedWorksheetTable
